import {LocalStorageService} from "./localStorageService.ts";
import {IChannel} from "../interfaces/IChannel.ts";
import {IRecommendation} from "../interfaces/IRecommendation.ts";
import {StorageKeys} from "../consts/storageKeys.ts";

export interface IRecommendationService {
    addVisitedCountOnChannel(chId: number) : void;
    getAll() : IRecommendation[];
    save(recommendationsList: IRecommendation[]): void;
    getRecommendedChannelList(allChannels: IChannel[], limit: number): IChannel[];
}

export class RecommendationService implements IRecommendationService {
    private _storageService: LocalStorageService;

    constructor() {
        this._storageService = new LocalStorageService();
    }

    addVisitedCountOnChannel(chId: number): void {
        const recommendationList = this.getAll();
        const index = recommendationList.findIndex((x) => x.chId === chId);
        if (index >= 0)
            recommendationList[index].visitedCount++;
        else
            recommendationList.push({chId: chId, visitedCount: 1});
        this.save(recommendationList);
    }

    // get recommendations from local storage and parse to IRecommendation[] object
    getAll(): IRecommendation[] {
        const recommendationList = this._storageService.getItem<IRecommendation[]>(StorageKeys.RECOMMENDATIONS_STORAGE_NAME);
        if (recommendationList)
            return recommendationList;
        return [];
    }

    // save to local storage
    save(recommendationsList: IRecommendation[]): void {
        this._storageService.setItem(StorageKeys.RECOMMENDATIONS_STORAGE_NAME, recommendationsList);
    }

    getRecommendedChannelList(allChannels: IChannel[], limit: number): IChannel[] {
        let recommendationList = this.getAll();
        const recommendedChannelList: IChannel[] = [];
        recommendationList = recommendationList.sort((x, y) => y.visitedCount - x.visitedCount);
        if(recommendationList.length > 3)
            recommendationList = recommendationList.slice(0, limit);
        recommendationList.map((x) => {
            const channel = allChannels.find(y => y.ch_id === x.chId);
            if (channel)
                recommendedChannelList.push(channel);
        })
        return recommendedChannelList;
    }
}